import endpoints from '@/utils/constants';
import { apiHelper } from '@/utils/helpers';
 
const actions = {

    saveRole(context){
        return new Promise((resolve,reject)=>{
            apiHelper.call('post',`${endpoints.BASE_URL}${endpoints.API.roles}`,context.state.role).then((res) => {
            if(res.status === 201){
                    resolve(res.data)
                }
            }).catch(err=>{
                reject(err);
            })
        })
    },

    getRoles(context){
        return new Promise((resolve,reject) => {
            apiHelper.call('get',`${endpoints.BASE_URL}${endpoints.API.roles}`)
            .then((res) => {
                if(res.status === 200){
                    context.commit('setRoles', res.data);
                    resolve(res.data)
                }
            }).catch(err=>{
                reject(err);
            })
        })
    },
    fetchRole(context,roleId){
        return new Promise((resolve,reject)=>{
            apiHelper.call('get',`${endpoints.BASE_URL}${endpoints.API.roles}/${roleId}`).then((res)=>{
                if(res.status === 200){
                    resolve(res.data);
                }
            }).catch(err =>{
                reject(err);
            })                          
        })
    },
    updateRole(context){
          return new Promise((resolve,reject)=>{
              apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.roles}/${context.state.role.roleId}`,context.state.role).then((res)=> {
                  if(res.status === 200)
                  {
                   context.commit('setRole', res.data);
                   resolve(res);
                  }
              }).catch(err =>{
                  reject(err);
              })
          });
      },

}

export default actions;